// extracted by mini-css-extract-plugin
export default {"primaryColor":"#f8cf40","primaryColorWithAlpha":"rgba(248,207,64,.1019607843)","mainBgColor":"#fff","secondBgColor":"#f4f4f4"};